export default __webpack_public_path__ + "static/media/six30labs.2f00fe25.png";